import {$,$$} from './dom.js';

export function initNavigation({motion}){
  const toast=$('#toast'),listeners=new Set(),nav=$('.nav');let toastTimer,lastScrollY=scrollY,navTicking=false;
  function say(message){toast.textContent=message;toast.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.classList.remove('show'),1700)}
  function showScreen(name){
    const target=$$('.screen').find(screen=>screen.dataset.screen===name);if(!target){if(name!=='home')showScreen('home');return}
    nav.classList.remove('nav-hidden');
    lastScrollY=0;
    $$('.screen').forEach(screen=>screen.classList.toggle('active',screen.dataset.screen===name));
    const parent=name==='jar'?'progress':['roll','mvd','parking','goal-filter','shredder','kindness'].includes(name)?'toolkit':['router','today','settings','welcome'].includes(name)?'home':name;
    $$('.nav button').forEach(button=>{const active=button.dataset.nav===parent;button.classList.toggle('active',active);if(active)button.setAttribute('aria-current','page');else button.removeAttribute('aria-current')});
    $('main').scrollTop=0;
    scrollTo({top:0,behavior:motion.isReduced()?'auto':'smooth'});
    const heading=target.querySelector('h1');if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true})}
    try{if(location.hash!==`#${name}`)history.pushState(null,'',`#${name}`)}catch{}
    listeners.forEach(listener=>listener(name));
  }
  $$('[data-open]').forEach(button=>button.addEventListener('click',()=>showScreen(button.dataset.open)));
  $$('[data-back]').forEach(button=>button.addEventListener('click',()=>showScreen(button.dataset.back)));
  $$('.nav button').forEach(button=>button.addEventListener('click',()=>showScreen(button.dataset.nav)));
  $$('.placeholder-home').forEach(button=>button.addEventListener('click',()=>showScreen('home')));
  function updateMobileNav(){
    const homeActive=$('[data-screen="home"].active');
    if(innerWidth>980||homeActive){nav.classList.remove('nav-hidden');lastScrollY=scrollY;navTicking=false;return}
    const currentY=scrollY;
    const delta=currentY-lastScrollY;
    if(currentY<48)nav.classList.remove('nav-hidden');
    else if(delta>10)nav.classList.add('nav-hidden');
    else if(delta<-7)nav.classList.remove('nav-hidden');
    lastScrollY=currentY;
    navTicking=false;
  }
  addEventListener('scroll',()=>{if(!navTicking){navTicking=true;requestAnimationFrame(updateMobileNav)}},{passive:true});
  addEventListener('resize',()=>{if(innerWidth>980)nav.classList.remove('nav-hidden')});
  addEventListener('popstate',()=>showScreen(location.hash.slice(1)||'home'));
  return {showScreen,say,onShow(listener){listeners.add(listener);return()=>listeners.delete(listener)}};
}
